import React, { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../../../store';
import { ISeason } from '../../../../../../store/seasons/store';

import { RegisteredSeasonsStyled } from './RegisteredSeasons.Styles';
import RegisteredSeason from './RegisteredSeason';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { sortBy } from '../../../../../../contrib/sortBy';

const RegisteredSeasons = () => {
  const { seasons: allSeasons } = useContext(GlobalContext);

  const { clubId } = useRouteInfoState();

  const [seasons, setSeasons] = useState<ISeason[]>([]);

  useEffect(() => {
    if (clubId && allSeasons[clubId]) {
      const clubSeasons = allSeasons[clubId].seasons;
      const sortedSeasons = sortBy(clubSeasons, 'dec', 'start');

      setSeasons(sortedSeasons);
    }
  }, [allSeasons, clubId]);

  return (
    <RegisteredSeasonsStyled>
      {seasons.map((season: ISeason) => (
        <RegisteredSeason season={season} />
      ))}
    </RegisteredSeasonsStyled>
  );
};

export default RegisteredSeasons;
